/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityScoreAnalysis
 */
export interface OpportunityScoreAnalysis {
    /**
     * Average opportunity score
     * @type {number}
     * @memberof OpportunityScoreAnalysis
     */
    averageScore: number;
    /**
     * Set of actionable improvements
     * @type {Set<string>}
     * @memberof OpportunityScoreAnalysis
     */
    actionableImprovements: Set<string>;
}

/**
 * Check if a given object implements the OpportunityScoreAnalysis interface.
 */
export function instanceOfOpportunityScoreAnalysis(value: object): value is OpportunityScoreAnalysis {
    if (!('averageScore' in value) || value['averageScore'] === undefined) return false;
    if (!('actionableImprovements' in value) || value['actionableImprovements'] === undefined) return false;
    return true;
}

export function OpportunityScoreAnalysisFromJSON(json: any): OpportunityScoreAnalysis {
    return OpportunityScoreAnalysisFromJSONTyped(json, false);
}

export function OpportunityScoreAnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityScoreAnalysis {
    if (json == null) {
        return json;
    }
    return {
        
        'averageScore': json['averageScore'],
        'actionableImprovements': json['actionableImprovements'],
    };
}

export function OpportunityScoreAnalysisToJSON(value?: OpportunityScoreAnalysis | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'averageScore': value['averageScore'],
        'actionableImprovements': Array.from(value['actionableImprovements'] as Set<any>),
    };
}

